import { RichMessageFieldsFragment, RichMessageInput } from '@anyx/common-graphql';
import { TrackingUrlArray, toUploadImageFile } from '@anyx/feature-crm/shared';
import { URLUtils } from '@anyx/shared-utils';

import {
  getManualActionURL,
  LineMessageBlockType,
  RichMessageBlock,
  UploadedImageFile,
} from '../../components';

import { UrlActionAdapter } from './url-action-adapter';

type RichMessageContent = {
  richMessage: RichMessageInput;
};

export type RichMessageWithImage = RichMessageBlock & { image: UploadedImageFile };
type RichMessageAdapter = {
  toGQL: (message: RichMessageWithImage) => RichMessageContent;
  toOriginalUrls: (message: RichMessageWithImage, trackingUrls: TrackingUrlArray) => string[];
  toMessageBlock: (content: RichMessageFieldsFragment) => RichMessageBlock;
};

export const richMessageAdapter: RichMessageAdapter = {
  toGQL: ({ image, actionUrl }) => {
    return {
      richMessage: {
        imageUrl: image?.src,
        urlAction: UrlActionAdapter.toGQL(actionUrl),
      },
    };
  },
  toOriginalUrls: ({ actionUrl }, trackingUrls) => {
    const originalUrl = trackingUrls.find(
      ({ trackingUrl }) => trackingUrl === getManualActionURL(actionUrl)
    )?.originalUrl;

    return originalUrl ? [URLUtils.encode(originalUrl)] : [];
  },
  toMessageBlock: ({ imageUrl, urlAction }) => ({
    type: LineMessageBlockType.enum.RICH,
    image: toUploadImageFile(imageUrl),
    actionUrl: UrlActionAdapter.toMessageBlock(urlAction ?? undefined),
  }),
};
